export default __webpack_public_path__ + "static/carmokun-cmbanner-0d3e10d1a37ab23afd2c3ac8068a5d2b.jpg";